import i18n from "../service/i18n";

const addLeadingZero = num => `${num < 10 ? "0" : ""}${num}`;

const destructDate = (date: Date): [number, number, number] => [
  date.getFullYear(),
  date.getMonth(),
  date.getDate()
];

const timeToString = (timestamp: string): string => {
  const date = new Date(timestamp);
  const hours = addLeadingZero(date.getHours());
  const minutes = addLeadingZero(date.getMinutes());
  return `${hours}.${minutes}`; // HH.mm
};

const dateToString = (
  timestamp: string,
  language: string,
  showYear: boolean | undefined = true
) => {
  const [year, month, day] = destructDate(new Date(timestamp));
  const date = new Date(year, month, day);
  const today = new Date(...destructDate(new Date()));
  const isToday = d => !(d.getTime() - today.getTime());
  const isTomorrow = d => d.getTime() - today.getTime() === 86400000; // 1000 * 60 * 60 * 24 == day in ms

  if (isToday(date)) {
    return i18n("tanaan", { language });
  } else if (isTomorrow(date)) {
    return i18n("huomenna", { language });
  } else {
    return `${day}.${month + 1}.${showYear ? year : ""}`; // D.M. || D.M.YYYY
  }
};

/**
 * E.g. "18.6.2018 klo 13.06"
 */

export const dateTimeString = (timestamp, language, showYear?): string =>
  timestamp
    ? `${dateToString(timestamp, language, showYear)} ${i18n("klo", {
        language
      })} ${timeToString(timestamp)}`
    : "";

interface StatusTextProps {
  onDemandViewable: boolean;
  upcomingStartTime?: string;
  language: string;
}

export const videoStatusText = ({
  language,
  onDemandViewable,
  upcomingStartTime
}: StatusTextProps): string => {
  const mainText = onDemandViewable
    ? i18n("ohjelma_on_tulossa_katsottavaksi", { language })
    : i18n("ohjelma_on_katsottavissa_vain_suorana", { language });

  return `${mainText} ${timeText(language, upcomingStartTime)}`;
};

export const timeText = (language: string, upcomingStartTime?: string) =>
  upcomingStartTime
    ? `${dateToString(upcomingStartTime, language)} ${i18n("klo", {
        language
      })} ${timeToString(upcomingStartTime)}`
    : "";
